import { pick } from 'lodash-es';
import { DateTime } from 'luxon';

import { PricingSchemeRead } from 'src/common/external/bambi-api/bambiApi';

import { defaultValues, SchemeMetaFormValues } from './metaDefaultValues';

export const getMetaDefaultValues = (
  originalPricingSchemeValues?: PricingSchemeRead
): SchemeMetaFormValues => {
  const now = DateTime.now();
  const startDate = now.toISODate();
  const endDate = now.plus({ years: 5 }).toISODate();

  const values = originalPricingSchemeValues
    ? pick(
        originalPricingSchemeValues,
        Object.keys(defaultValues).filter((key) => key !== 'payer_ids')
      )
    : {
        ...defaultValues,
        start_date: startDate,
        end_date: endDate,
      };

  return values as SchemeMetaFormValues;
};
